import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Moment from 'moment'
import {Link} from "react-router-dom"
import BillingCollapse from "./BillingCollapse"

class BillingRecord extends Component {
    state = {
        collapse: false,
    }

    _toggleCollapse = () => {
        this.setState(prevState => ({
            collapse: !prevState.collapse
        }))
    }

    render() {
        const {billingRecord} = this.props
        const {collapse} = this.state
        const now = Moment()
        const createdTime = Moment(billingRecord.created)
        const backwardTime = Moment.duration(createdTime.diff(now))
        const isCollapsable = !!billingRecord.extend
        return (
            <div className='BillingRecord'>
                <div className='row table-row' onClick={this._toggleCollapse}>
                    <div className='col-3'><Link
                        to={`/a/users/${billingRecord.owner._id}`}>{billingRecord.owner.name}</Link></div>
                    <div className='col-3'>{billingRecord.plan.title}
                        {isCollapsable && <span className='extend-arrow'>&#x25BC;</span>}
                    </div>
                    <div className='col-2'>{billingRecord.coupon}</div>
                    <div className="col">{billingRecord.method}</div>
                    <div className='col'>
                        <div className='tooltip-container'>{backwardTime.humanize(true)}
                            <span
                                className="tooltip-text">{createdTime.format('DD-MM-YYYY')}</span>
                        </div>
                    </div>
                    <div className='col'>{`${billingRecord.price} ${billingRecord.currency}`}</div>
                </div>
                {
                    isCollapsable && <BillingCollapse collapse={collapse} extend={billingRecord.extend}/>
                }

            </div>
        )
    }
}

BillingRecord.propType = {
    billingRecord: PropTypes.object.isRequired,
}


export default BillingRecord



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/billings/BillingsPage/BillingRecord.js